/**
 * TutorialLayer — body-level portal host for the spotlight + coach card.
 *
 * The production Round End / Match End overlays (GameplayBackdrop) inert
 * every pre-existing direct child of document.body while active. The
 * tutorial's instructional chrome must stay interactive ON TOP of them
 * (that is where the scoring lessons happen), so it renders through a
 * dedicated portal container marked data-ds2-inert-exempt — the canonical
 * modal system's own exemption hook. Deliberately NOT data-ds2-modal-root:
 * the coach card must not claim modal/Escape ownership.
 */
import { useState, useLayoutEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export function TutorialLayer({ children }: { children: ReactNode }) {
  const [host, setHost] = useState<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const el = document.createElement('div');
    el.setAttribute('data-ds2-inert-exempt', '');
    document.body.appendChild(el);
    setHost(el);
    return () => {
      document.body.removeChild(el);
    };
  }, []);

  return host ? createPortal(children, host) : null;
}
